module.exports = {
  "wxc-overlay": {
    "width": "750",
    "position": "fixed",
    "bottom": 0,
    "right": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-440361d4!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-overlay/index.vue
// module id = 173
// module chunks = 0 1